import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";

import Constants from "common/Constants";
import { callPost, ConstantsServer } from "utils/CommonApi";
import PenderManager from "utils/PenderManager";

import AatbHeader from "components/mypage/myAatb/AatbHeader";
import AatbMain from "components/mypage/myAatb/AatbMain";
import PrimeAatbHeader from "components/mypage/myAatb/PrimeAatbHeader";
import AatbPrimeMain from "components/mypage/myAatb/AatbPrimeMain";
import Footer from "components/init/Footer";
import AlertConfirmPopup from "components/common/AlertConfirmPopup";
import AiMathExamStartPopup, { preloadAiMathExamStartImages } from "components/aicenter/AiMathExamStartPopup";
import { modify } from "store/modules/common/loginReducer";
import useMemberShip from "store/customHooks/useMemberShip";
import useSpinner from "store/customHooks/useSpinner";

const StepAatbOptions = (props) => {
    const { myInitInfo, reset, saveAatbInfo, setSaveAatbInfo, stepToggle, stepTab, isPrimePedcCd } = props;

    const loginInfo = useSelector((state) => state.loginReducer);
    const pedcCd = useSelector((state) => state.loginReducer.pedcCd);
    const orininGradCd = useSelector((state) => state.loginReducer.gradCd);
    const mmbrSeq = useSelector((state) => state.loginReducer.mmbrSeq);
    const subscriberType = useSelector((state) => state.loginReducer.subscriberType);

    const headerParam = {
        user_id: loginInfo.userId,
    };

    //Class Info Pender
    const [PendigProgress] = PenderManager();

    /* 탭 관련 상태값 */
    const [activeTab, setActiveTab] = useState("");
    const [chk, setChk] = useState(-1);

    /* AI수학 진단평가 시작 팝업 (응시 가능한 진단평가가 있을 때 노출) */
    const [examStartOpen, setExamStartOpen] = useState(false);
    // 시작하기 URL 조립에 사용할 진단평가 응답 정보 (SMST_CD, EXAM_SEQ)
    const [examInfo, setExamInfo] = useState(null);
    // 저장 클릭 시점에 시작한 팝업 이미지 프리로드 Promise
    const preloadPromiseRef = useRef(null);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const dispatch = useDispatch();
    const history = useHistory();

    const { openSpinner, closeSpinner } = useSpinner();
    const { ckLTAL, ckLTAL_ALTB, ckALTB } = useMemberShip();

    const LTAL = ckLTAL();
    const LTAL_ALTB = ckLTAL_ALTB();
    const ALTB = ckALTB();

    const isLightAndAlltabMember = LTAL || LTAL_ALTB || ALTB;

    // GR20(예비중) 여부 체크
    const isPreGrade = myInitInfo.gradCd === "GR20";

    const pedcCheckDate = moment().format("YYYYMMDD");
    const initSaveAatbInfo = useRef([]);

    /* 탭 출판사 상태값 */
    const [aatbList, setAatbList] = useState({
        KORN: "미설정",
        ENGM: "미설정",
        MATH: "미설정",
        SOSI: "미설정",
        HIST: "미설정",
        SCNE: "미설정",
    });

    /* 교과서 설정 관련 상태값  */
    const aatbType = Object.keys(aatbList);

    const subjectCode = (code) => {
        const subjectCode = {
            "PEDC-00015": "ENGM",
            "PEDC-00016": "MATH",
        };
        return subjectCode[code];
    };

    const [mmbrAatbInfo, setMmbrAatbInfo] = useState({
        gradInfo: { gradCd: myInitInfo.gradCd, gradNm: "" },
        schlInfo: { schlCd: myInitInfo.schlCd, schlNm: "" },
        aatbList: [],
        courseGrpCdList: "", // 과목 그룹 코드 리스트
    });

    /* 공통 모달 호출 */
    const callAlertPopup = async (modalInfo) => {
        const reqData = {
            title: modalInfo.title,
            type: modalInfo.type,
            msg: modalInfo.msg,
        };

        return await AlertConfirmPopup(reqData);
    };

    useEffect(() => {
        // 학년, 학교 가 변경된 경우, 초기화 버튼 시 재조회
        // setPending();
        let queryParam = {
            STD_SCHL_CD: myInitInfo.schlCd,
            GRAD_CD: myInitInfo.gradCd,
            SMST_CD: "",
            COURSE_GRP_CD: "",
            COURSE_ALL: "Y", // 전체 과목 조회
        };

        if (myInitInfo.schlCd) {
            callSchlAatbList(queryParam);
        }
    }, [myInitInfo.schlCd, myInitInfo.gradCd]);

    useEffect(() => {
        // 초기화 버튼 시 재 조회
        if (stepTab === "2") {
            // setPending();

            let queryParam = {
                STD_SCHL_CD: myInitInfo.schlCd,
                GRAD_CD: myInitInfo.gradCd,
                SMST_CD: "",
                COURSE_GRP_CD: "",
                COURSE_ALL: "Y", // 전체 과목 조회
            };

            if (myInitInfo.schlCd) {
                callSchlAatbList(queryParam);
            }
        }
    }, [reset]);

    const callSchlAatbList = (queryParam) => {
        const param = {
            REQUEST_API:
                Constants.MYPAGE_API.SCHL_AATB_LIST + (LTAL || LTAL_ALTB || ALTB ? `&MMBR_SEQ=${mmbrSeq}` : ""),
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        callPost(
            headerParam,
            param,
            (resData) => {
                let tmpSchlGradInfo = resData.RESP_RESULT.SCHL_GRAD_INFO;
                let tmpAatbInfo = resData.RESP_RESULT.SCHL_AATB_LIST;

                tmpAatbInfo = tmpAatbInfo.filter(
                    (item, index, self) => index === self.findIndex((t) => t.COURSE_GRP_CD === item.COURSE_GRP_CD),
                );

                // 초기값 설정
                initSaveAatbInfo.current = tmpAatbInfo;
                setSaveAatbInfo(tmpAatbInfo);

                setMmbrAatbInfo({
                    ...mmbrAatbInfo,
                    gradInfo: { gradCd: tmpSchlGradInfo.GRAD_CD, gradNm: tmpSchlGradInfo.GRAD_NM },
                    schlInfo: { schlCd: tmpSchlGradInfo.STD_SCHL_CD, schlNm: tmpSchlGradInfo.SCHL_NM },
                    aatbList: tmpAatbInfo,
                    courseGrpCdList: resData.RESP_RESULT?.COURSE_GRP_CD_LIST || "",
                });

                // 선택 과목 교과서 목록 조회 (후 chk 값 변경)
                toggle("1");
            },
            queryParam,
        );
    };

    const handleClickBack = () => {
        setSaveAatbInfo([...initSaveAatbInfo.current]);
        toggle("");
        stepToggle("1");
    };

    const notSetSubjectList = Object.entries(aatbList)
        .splice(0, Object.values(aatbList).length)
        .filter(([, course]) => course === "미설정")
        .map((item) => item[0]);

    const notSetSubjectName = (notSetSubjectList) => {
        const subjectArr = [];
        const notSetSubjectName = {
            KORN: "국어",
            ENGM: "영어",
            MATH: "수학",
        };
        notSetSubjectList.map((item) =>
            Object.entries(notSetSubjectName).filter(([key, value]) => item === key && subjectArr.push(value)),
        );
        return subjectArr;
    };

    // membership 학년 수정
    const mmbrGradUpdate = () => {
        let queryParam = {
            MMBR_SEQ: mmbrSeq,
            GRAD_CD: myInitInfo.gradCd,
        };
        const param = {
            REQUEST_API: Constants.MEMBERSHIP_API.UPDATE_GRAD,
            HTTP_METHOD: Constants.HTTP_METHOD.PUT,
            DOMAIN: ConstantsServer.SERVER_DOMAIN.GW_SMARTALL_MID_DOMAIN,
            BODY: {
                GRAD_CD: myInitInfo.gradCd,
            },
        };
        callPost(
            headerParam,
            param,
            (resData) => {
                setRedisContext();
            },
            queryParam,
        );
    };

    // 학년 redis update
    const setRedisContext = async () => {
        let queryParam = {
            MMBR_SEQ: mmbrSeq,
            GRAD_CD: myInitInfo.gradCd,
        };
        const param = {
            URL: "/common/setRedisContext",
            HTTP_METHOD: Constants.HTTP_METHOD.POST,
            BODY: {
                GRAD_CD: myInitInfo.gradCd,
            },
        };

        await callPost(
            headerParam,
            param,
            (resData) => {
                // 학교, 교과서 설정, 스케줄 초기화
                dispatch(
                    modify({
                        gradCd: resData.GRAD_CD,
                    }),
                );
                initSaveStudyPlan();
            },
            queryParam,
        );
    };

    const handleClickSave = useCallback(() => {
        if (
            Object.values(aatbList)
                .splice(0, Object.values(aatbList).length - 3)
                .includes("미설정")
        ) {
            callAlertPopup({
                title: "알림",
                type: "ALERT",
                msg: `학교에 설정된<br /><strong>${notSetSubjectName(notSetSubjectList).join(", ")}</strong><br />
                교과서가 없습니다.<br /><br />교과서를 선택해주세요.`,
            });
        } else {
            // 저장 API 시퀀스와 병렬로 팝업 이미지 프리로드 시작 (스피너 동안 미리 로드)
            preloadPromiseRef.current = preloadAiMathExamStartImages();
            // 학년 변경 시 학년 업데이트 선행 → 표준 시간표 조회 → 저장
            if (orininGradCd != myInitInfo.gradCd) {
                mmbrGradUpdate(); // setRedisContext → initSaveStudyPlan 체인
            } else {
                initSaveStudyPlan();
            }
        }
    }, [aatbList, myInitInfo.gradCd]);

    // 교과서(AATB) 목록 빌더 (조회/저장 공용)
    const buildAatbList = () =>
        saveAatbInfo
            .filter((value) => Boolean(value.AATB_SEQ))
            .map((value) => ({
                GRAD_CD: String(value.GRAD_CD || ""),
                SMST_CD: String(value.SMST_CD || ""),
                COURSE_CODE: String(value.COURSE_CODE || ""),
                AATB_SEQ: String(value.AATB_SEQ || ""),
            }));

    const buildPrimeParam = () =>
        pedcCd === "PEDC-00015" || pedcCd === "PEDC-00016"
            ? `&LVL_CD=${myInitInfo.primeLevel}&PEDC_WEEK_SEQ=${myInitInfo.primeWeek}`
            : "";

    // 표준 시간표 조회 응답 → WEEK_COURSE_LIST 가공 (월~일 순, DSP_NO 1-based)
    const buildWeekCourseList = (stdList) => {
        const WK_ORDER = ["2", "3", "4", "5", "6", "7", "1"]; // 월·화·수·목·금·토·일
        return WK_ORDER.map((wkCd) => ({
            WK_CD: wkCd,
            COURSE_LIST: stdList
                .filter((tmtble) => tmtble.WK_CD === wkCd)
                .map((tmtble, idx) => ({ COURSE_CODE: tmtble.COURSE_CODE, DSP_NO: idx + 1 })),
        }));
    };

    // 1) 표준 시간표 조회
    const initSaveStudyPlan = () => {
        const queryParam = {
            GRAD_CD: myInitInfo.gradCd,
            MMBR_SEQ: mmbrSeq,
        };
        const param = {
            REQUEST_API:
                Constants.STUDY_PLAN_API.STD_TMTLB_LIST + "?TODAY=" + pedcCheckDate + "&TYPE=INIT" + buildPrimeParam(),
            HTTP_METHOD: Constants.HTTP_METHOD.POST,
            BODY: {
                AATB_LIST: buildAatbList(),
            },
        };

        openSpinner({ color: "#f7901e", backdropColor: "#000" });
        callPost(headerParam, param, callbackStdTmtblList, queryParam);
    };

    // 2) 조회 결과 → 가공 후 저장
    const callbackStdTmtblList = (resData) => {
        saveTimeTable(buildWeekCourseList(resData.RESP_RESULT.STD_TMTLB_LIST));
    };

    // 3) 시간표 저장
    const saveTimeTable = (weekCourseList) => {
        const queryParam = {
            MMBR_SEQ: mmbrSeq,
            GRAD_CD: myInitInfo.gradCd,
        };

        try {
            const param = {
                REQUEST_API: Constants.STUDY_PLAN_API.SAVE_STUDY_PLAN + "?TODAY=" + pedcCheckDate + buildPrimeParam(),
                HTTP_METHOD: Constants.HTTP_METHOD.POST,
                BODY: {
                    SCHL_CD: myInitInfo.schlCd,
                    AATB_LIST: buildAatbList(),
                    WEEK_COURSE_LIST: weekCourseList, // 요일별 과목
                },
            };

            callPost(headerParam, param, callbackClickSave, queryParam);
        } catch (e) {
            console.log("error");
            closeSpinner();
        }
    };

    // 저장 완료 후 마지막으로 응시 가능한 수학 진단평가 조회
    const callbackClickSave = (resData) => {
        callAbilityExam();
    };

    // 응시 가능한 수학 진단평가 조회 (마지막 호출)
    const callAbilityExam = () => {
        const queryParam = {
            MMBR_SEQ: mmbrSeq,
            PEDC_CD: pedcCd,
            GRAD_CD: myInitInfo.gradCd,
        };
        const param = {
            REQUEST_API: Constants.ABILITY_EXAM_API.AVAILABLE_EXAM,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        callPost(headerParam, param, callbackAbilityExam, queryParam);
    };

    // 응시 가능한 진단평가가 있으면(EXAM_EXIST_YN === "Y") AI수학 진단평가 시작 팝업 노출
    const callbackAbilityExam = (resData) => {
        const examInfo = resData?.RESP_RESULT;
        console.log("[StepAatbOptions] 응시 가능한 수학 진단평가 조회 응답:", examInfo);

        // 최초입회(InitTimeTable) 경로로 메인 진입함을 표시 (메인에서 이벤트팝업 조회 시 파라미터 부착용)
        sessionStorage.setItem("afterInitTmtbl", "1");

        if (examInfo?.EXAM_EXIST_YN !== "Y") {
            // 응시 가능한 진단평가가 없으면 메인화면으로 이동
            closeSpinner();
            history.replace("/today/middleStudyToday");
            return;
        }

        // 시작하기 시 사용할 SMST_CD, EXAM_SEQ 보관
        setExamInfo(examInfo);

        // 이미지 프리로드 완료까지(최대 2500ms) 스피너 유지 후 완성된 팝업 노출
        const preload = preloadPromiseRef.current || Promise.resolve();
        const timeout = new Promise((resolve) => setTimeout(resolve, 2500));
        Promise.race([preload, timeout]).finally(() => {
            closeSpinner();
            setExamStartOpen(true);
        });
    };

    return (
        <div className={`textbookWrap${isPreGrade ? " preGradeWrap" : ""}`}>
            <PendigProgress />
            {isPreGrade ? (
                <div className="preGradeNotice">
                    <p>
                        예비중 학년은 별도 교과서 정보가 없어도 학습 가능합니다.
                        <br />
                        표준 시간표를 변경하기 원한다면 '다음'을 선택해 주세요.
                    </p>
                </div>
            ) : (
                <>
                    <div className="topText">
                        <span>
                            {mmbrAatbInfo.gradInfo.gradNm} '{mmbrAatbInfo.schlInfo.schlNm}'
                        </span>
                        <div>
                            <p>
                                학교마다 출판사 정보가 다를 수 있으니, 한번 더 확인 후 설정해 주세요. (교과서 정보 기준
                                : {mmbrAatbInfo.aatbList[0]?.YR}년 1월)
                            </p>
                        </div>
                    </div>
                    <div className="textbookTabWrap">
                        {isPrimePedcCd ? (
                            <>
                                <PrimeAatbHeader activeTab={activeTab} toggle={toggle} mmbrAatbList={saveAatbInfo} />
                                <AatbPrimeMain
                                    activeTab={activeTab}
                                    aatbType={subjectCode(pedcCd)}
                                    gradInfo={mmbrAatbInfo.gradInfo}
                                    mmbrAatbList={saveAatbInfo}
                                    setSaveAatbInfo={setSaveAatbInfo}
                                    chk={chk}
                                    setChk={setChk}
                                />
                            </>
                        ) : (
                            <>
                                <AatbHeader
                                    activeTab={activeTab}
                                    toggle={toggle}
                                    mmbrAatbList={saveAatbInfo}
                                    setAatbList={setAatbList}
                                    courseGrpCdList={mmbrAatbInfo.courseGrpCdList}
                                />
                                <AatbMain
                                    activeTab={activeTab}
                                    aatbType={aatbType}
                                    gradInfo={mmbrAatbInfo.gradInfo}
                                    mmbrAatbList={saveAatbInfo}
                                    setSaveAatbInfo={setSaveAatbInfo}
                                    chk={chk}
                                    setChk={setChk}
                                />
                            </>
                        )}
                    </div>
                </>
            )}
            <Footer
                handleClickBack={handleClickBack}
                handleClickSave={handleClickSave}
                btnInfo={{ backNm: "이전", saveNm: "저장" }}
            />
            <AiMathExamStartPopup
                isOpen={examStartOpen}
                onClose={() => setExamStartOpen(false)}
                mmbrSeq={mmbrSeq}
                gradCd={myInitInfo.gradCd}
                smstCd={examInfo?.SMST_CD}
                examSeq={examInfo?.EXAM_SEQ}
            />
        </div>
    );
};
export default StepAatbOptions;
